import React, { forwardRef, useRef } from "react";
import { useController } from "react-hook-form";
import mergeRefs from "react-merge-refs";

export interface SearchProps {
  onKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onSearch: () => void;
}

function withSearch<P>(Component: React.ComponentType<P & SearchProps>) {
  const SearchComponent = forwardRef<HTMLInputElement, P>((props, ref) => {
    const searchRef = useRef<HTMLInputElement>(null);

    const { field } = useController({
      name: "searchText",
      defaultValue: "",
    });

    const onSearch = () => {
      field.onChange(searchRef?.current?.value ?? "");
      field.onBlur();
    };

    const onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
      if (e.key === "Enter") {
        onSearch();
      }
    };

    const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      if (!e.target.value) {
        field.onChange("");
      }
    };

    return (
      <Component
        {...props}
        onKeyDown={onKeyDown}
        onChange={onChange}
        onSearch={onSearch}
        ref={mergeRefs([ref, searchRef])}
      />
    );
  });

  SearchComponent.displayName = "SearchComponent";

  return SearchComponent;
}

export default withSearch;
